import { render, staticRenderFns } from "./TeacherCardNextLabel.vue?vue&type=template&id=628f06ba&scoped=true&"
import script from "./TeacherCardNextLabel.vue?vue&type=script&lang=js&"
export * from "./TeacherCardNextLabel.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardNextLabel.vue?vue&type=style&index=0&id=628f06ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f06ba",
  null
  
)

export default component.exports